import React, { useCallback, useMemo, useRef, useState } from 'react';
import Section, { size } from '../components/generic/Section';

import DeviceSequence from '../components/Device/DeviceSequence';
import GetInTouch from '../components/Workspace/GetInTouch';
import Head from '../components/Head';
import ProductComparison from '../components/ProductComparison';
import ProductList from '../components/ProductList';
import WorkspaceDevices from '../components/WorkspaceGrid/WorkspaceDevices';
import { graphql } from 'gatsby';
import { headerHeight } from '../utils/menuHeight';
import { isOnServer } from '../utils';
import styles from './device.module.scss';
import { uniqueArrayByKey } from '../utils/uniqueArrayByKey';
import { useThrottledOnScroll } from '../utils/useOnScrollThrottled';

export const query = graphql`
  query($id: String!) {
    contentfulDevice(id: { eq: $id }) {
      ...Device
    }
  }
`;

export default function DevicePage(props) {
  let productListElemRef = useRef(null);
  let pageData = props.data.contentfulDevice;
  let location = props.location;

  let workspaces = useMemo(() => {
    let flatArray = pageData.products
      ?.map(product => product.bundles?.map(bundle => bundle.workspace?.[0]))
      ?.flat(4)
      .filter(item => item !== undefined);
    return uniqueArrayByKey(flatArray, el => el?.id);
  }, [pageData.products]);

  const scrollHeight = () => document.documentElement.clientHeight - headerHeight;
  let [pageHeight, setPageHeight] = useState(!isOnServer ? scrollHeight() : 0);
  let updateHeight = useCallback(() => setPageHeight(scrollHeight()), []);
  useThrottledOnScroll(updateHeight);

  if (!pageData.sections) return null;
  return (
    <>
      <Head
        location={location}
        title={pageData.heading}
        description={pageData.description.description}
        image={pageData.thumbnail?.file.url}
      />

      <DeviceSequence pageData={pageData} productListRef={productListElemRef} scrollPageHeight={pageHeight} />
      <Section size={size.full} className={styles.sectionHeader}>
        <h4>{pageData.productsTitle}</h4>
      </Section>
      <ProductList ref={productListElemRef} products={pageData.products} />
      {!pageData.hideProductComparison && <ProductComparison products={pageData.products} />}
      <WorkspaceDevices heading={pageData.workspacesTitle} description={''} workspaces={workspaces} />
      <GetInTouch />
    </>
  );
}

export const fragment = graphql`
  fragment Device on ContentfulDevice {
    __typename
    id
    heading
    slug
    description {
      description
    }
    thumbnail {
      ...Image
    }
    animationUrl
    animationUrlMobile
    animationFrames
    sections {
      ... on ContentfulDeviceSection {
        id
        __typename
        heading
        shortHeading
        description {
          raw
          references {
            ...RichTextAssetBase
          }
        }
        textPosition
        display
        custom {
          xoffset
          yoffset
        }
        mainFrame
        product: productLink {
          ...Product
        }
      }
    }
    productsTitle
    defaultProduct {
      ...Product
    }
    products {
      ...Product
      bundles: product_bundle {
        workspace {
          ...WorkspaceGridCard
        }
      }
    }
    hideProductComparison
    workspacesTitle
  }
`;
